import React from 'react';
import { Helmet } from 'react-helmet';
export function SchemaMarkup() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Rex Technologies',
    url: 'https://rextechnologies.co.uk',
    logo: 'https://rextechnologies.co.uk/logo.png',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+92 311 2148225',
      contactType: 'customer service',
      areaServed: ['GB', 'US'],
      availableLanguage: 'English'
    },
    sameAs: ['https://www.facebook.com/rextechnologies', 'https://twitter.com/rextechnologies', 'https://www.linkedin.com/company/rextechnologies']
  };
  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Rex Technologies',
    image: 'https://rextechnologies.co.uk/office.jpg',
    telephone: '+92 311 2148225',
    address: {
      '@type': 'PostalAddress',
      streetAddress: '123 Tech Street',
      addressLocality: 'London',
      postalCode: 'EC1A 1BB',
      addressCountry: 'UK'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 51.5074,
      longitude: -0.1278
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
      opens: '09:00',
      closes: '18:00'
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '124'
    }
  };
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [{
      '@type': 'Question',
      name: 'What services does Rex Technologies offer?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We offer comprehensive digital solutions including custom Web Design, Mobile App Development (iOS & Android), E-commerce solutions, and Digital Marketing services.'
      }
    }, {
      '@type': 'Question',
      name: 'How much does a website cost?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Our pricing is project-based. A basic brochure website starts from £500, while complex custom applications vary based on requirements. Contact us for a detailed quote.'
      }
    }, {
      '@type': 'Question',
      name: 'How long does it take to build a mobile app?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'A standard mobile app typically takes 8-12 weeks to develop, depending on complexity, features, and platform requirements.'
      }
    }, {
      '@type': 'Question',
      name: 'Do you offer post-launch support?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, we provide 3 months of free support with every project and offer ongoing maintenance packages thereafter.'
      }
    }, {
      '@type': 'Question',
      name: 'Are your websites mobile-friendly?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Absolutely. We follow a mobile-first approach ensuring all our websites are fully responsive and optimized for all devices.'
      }
    }
    // Note: Full 20 items are rendered in the visible FAQ component, schema includes key ones for brevity/SEO relevance
    ]
  };
  return <Helmet data-id="element-152">
      <script type="application/ld+json" data-id="element-153">
        {JSON.stringify(organizationSchema)}
      </script>
      <script type="application/ld+json" data-id="element-154">
        {JSON.stringify(localBusinessSchema)}
      </script>
      <script type="application/ld+json" data-id="element-155">{JSON.stringify(faqSchema)}</script>
    </Helmet>;
}